import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import PaginationComponent from '../../../goalManagement/PaginationComponent';
import NoDataFound from '../../../../../components/NodataIndication/NoDataFound';
import { getAllKras, getKraUserSpecific } from '../../../../../redux/features/appraisalSlice';
import KraCard from './KraCard';
import DeleteKra from './DeleteKra';
import MotionWrapper from '../../../../../components/MotionWrapper';
import LoadingSkeleton from '../../../../L&D/Appraisal/golas/TeamGoals/LoadingSkelton';
import AddKraUserSpecific from './AddKraUserSpecific';

const KraLanding = ({ user, induvidualView }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [kraApiGetCallAfterTrigger, setKraApiGetCallAfterTrigger] = useState(false);
  const { kraUserSpecificData, loading } = useSelector((state) => state.appraisal);
  const [selectedKraId, setSelectedKraId] = useState(null);
  const dispatchData = {
    type: 'kra',
    userTypeId: '',
    user: user,
  };
  const deleteAction = (id) => {
    setSelectedKraId(id);
    setOpen(true);
  };

  useEffect(() => {
    const data = { type: 'kra', search: '' };
    dispatch(getAllKras(data));
  }, []);
  return (
    <Box>
      {!induvidualView && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pb: 1 }}>
          <AddKraUserSpecific userId={user?.userID || ''} update={setKraApiGetCallAfterTrigger} />
        </Box>
      )}

      {loading ? (
        <LoadingSkeleton />
      ) : (
        <>
          {Array.isArray(kraUserSpecificData?.data) && kraUserSpecificData?.data?.length > 0 ? (
            kraUserSpecificData?.data.map((item, i) => (
              <Box key={item?.sl_no}>
                <MotionWrapper direction={'top'} delay={i * 0.1}>
                  <KraCard data={item} deleteAction={deleteAction} induvidualView={induvidualView}/>
                </MotionWrapper>
              </Box>
            ))
          ) : (
            <NoDataFound />
          )}
        </>
      )}

      <Box>
        <Box pt={2}>
          <PaginationComponent
            api={getKraUserSpecific}
            otherProps={dispatchData}
            loading={loading}
            meta={kraUserSpecificData.meta}
            dependencyFields={[kraApiGetCallAfterTrigger]}
          />
        </Box>
      </Box>
      <DeleteKra
        selectedKraId={selectedKraId}
        setSelectedKraId={setSelectedKraId}
        open={open}
        setOpen={setOpen}
        setKraApiGetCallAfterTrigger={setKraApiGetCallAfterTrigger}
      />
    </Box>
  );
};

export default KraLanding;
